module.exports = __webpack_public_path__ + "static/media/pf4-downstream-bg.5a6958f1.svg";